import { requestGet } from '../../utils/request';

const BASE_URL = '/api/user/v2';

export function requestUserDetails(userId) {
  return requestGet(`${BASE_URL}/details?userId=${userId}`, {
    mockFile: 'user/farmer',
  });
}
